export default __webpack_public_path__ + "static/char-30-anr-1b0366488685fe2837de195c5ce6f9d6.webp";